import {usePage} from "@inertiajs/vue3";

export default class Auth {
  /**
   * @param {PrivacyVault} privacy
   */
  static logout(privacy) {
    const page = usePage();
    const redirectUrl = page.props.links.p4u + "/medicheck-logout";

    // this is required for dev, because the target site will not be able to clear the cookies
    document.cookie = "mc_token=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";

    privacy.purgeLocalStorage();

    window.location.href = redirectUrl;
  }
}
